var cifGa = ["301 225", "<g fill='none'><path fill='#3A75C4' d='M.5 0h300v225H.5z'/><path fill='#FCD116' d='M.5 0h300v150H.5z'/><path fill='#009E60' d='M.5 0h300v75H.5z'/></g>"];

export { cifGa };

